// Compare to ../ServerRouterApp.jsx
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import apolloClient from 'appDir/lib/apollo/client';
import finalCreateStore from '../store/organizationConfigStore';
import Routes from '../routes/routes';
import { ApolloProvider } from '@apollo/client';
import muiThemeV0 from 'appDir/lib/muiThemeV0';
import { CloudinaryContext } from 'cloudinary-react';

const OrganizationConfigApp = (props, railsContext) => {
  const store = finalCreateStore(props, railsContext);

  return (
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <CloudinaryContext cloudName={railsContext.cloudinaryCloudName}>
          <MuiThemeProvider muiTheme={muiThemeV0}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <BrowserRouter>
                <Routes props={props} />
              </BrowserRouter>
            </MuiPickersUtilsProvider>
          </MuiThemeProvider>
        </CloudinaryContext>
      </ApolloProvider>
    </Provider>
  );
};

export default OrganizationConfigApp;
